var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashbordIconPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pending",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.656,
    height: 31.781,
    viewBox: "0 0 31.656 31.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M411,8.782v5.662h5.662Z",
    transform: "translate(-385.551 -8.237)",
    fill: "#e95852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M138.07,8.069a.931.931,0,0,1-.931-.931V0H123.793A2.8,2.8,0,0,0,121,2.793V13.2c.307-.028.617-.043.931-.043a10.225,10.225,0,0,1,7.895,3.724h10.106a.931.931,0,1,1,0,1.862h-8.879a10.164,10.164,0,0,1,1.078,3.724h7.8a.931.931,0,1,1,0,1.862h-7.8a10.245,10.245,0,0,1-4.317,7.449h14.6a2.8,2.8,0,0,0,2.793-2.793V8.069Zm1.862,5.09H126.276a.931.931,0,1,1,0-1.862h13.656a.931.931,0,1,1,0,1.862Z",
    transform: "translate(-113.551)",
    fill: "#e95852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M9.38,242a8.38,8.38,0,1,0,8.38,8.38A8.389,8.389,0,0,0,9.38,242Zm2.483,9.311H9.38a.931.931,0,0,1-.931-.931v-3.724a.931.931,0,1,1,1.862,0v2.793h1.552a.931.931,0,0,1,0,1.862Z",
    transform: "translate(-1 -226.979)",
    fill: "#e95852"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIconPending);
export default __webpack_public_path__ + "static/media/dashbord-icon-pending.478d3c6949e5924c9472c6f7c9f86603.svg";
export { ForwardRef as ReactComponent };